import React from "react";
import { INLINES, BLOCKS } from '@contentful/rich-text-types';
import idCreator from './idCreator';
import { get } from "lodash";
import TermsTable from "../components/Terms/TermsTable";

const headingBlocks = [1, 2, 3, 4, 5, 6].reduce((acc, currval) => {
  const reduceBlocks = {};
  const headinBlocks = BLOCKS[`HEADING_${currval}`];
  reduceBlocks[headinBlocks] = ({ data }, children) => {
    // recursion to drill downn and get content of header
    function getString(blockChildren) {
      if ("string" === typeof blockChildren) {
        return blockChildren;
      }
      if ("string" === typeof blockChildren[0]) {
        return blockChildren[0];
      }
      return getString(get(blockChildren, '0.props.children', []));
    }
    const name = idCreator(getString(children));
    const CustomTag = `h${currval}`;

    return <CustomTag id={`${name}`} variant={`h${currval}`}>{children}</CustomTag>
  }
  return {...acc, ...reduceBlocks};
}, {})

const renderOptions = {
  renderNode: {
    ...headingBlocks,
    [INLINES.HYPERLINK]: ({ data }, children) => (
      <a href={data.uri}>{children}</a>
    ),
    [BLOCKS.TABLE]: (data, children) => <TermsTable>{children}</TermsTable>
  }
};

export default renderOptions;
